import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountService } from 'src/app/services/modelService/account.service';

@Component({
  selector: 'app-donation-card-details',
  templateUrl: './donation-card-details.component.html',
  styleUrls: ['./donation-card-details.component.scss'],
})
export class DonationCardDetailsComponent implements OnInit {
  @Input() donation: any;
  constructor(public acs: AccountService) { }

  ngOnInit() { }

}
